import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { metadataService, DocumentApi } from "../../_services";
import { SlBusyIndicator } from "../editors";
import NotificationModal from "./NotificationModal";
import { DocumentCard } from "./LeadDocuments";
import { Row } from 'reactstrap';
import Persona from './Persona';

class GuestLeadDocuments extends Component {
  constructor(props) {
      super(props);

    this.state = {
      notificationModalOpen: false,
      notificationModalMessage: "",
      uploaded: {
        [DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT]: [],
        [DocumentApi.DOCUMENT_CLASSIFICATION_INCOME]: [],
        [DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE]: [],
      },
        personaComplete: false
    };
  }

  closeNotificationModal = () => {
    this.setState({
      notificationModalOpen: false,
      notificationModalMessage: "",
    });
  };

  getClassificationText(classification) {
    switch (classification) {
      case DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT:
        return metadataService.getTitle("ProofOfIdentity");
      case DocumentApi.DOCUMENT_CLASSIFICATION_INCOME:
        return metadataService.getTitle("ProofOfIncome");
      case DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE:
        return metadataService.getTitle("ProofOfResidence");
      default:
        return "";
    }
  }

  openNotificationModal = (savedDocument) => {
    if (!savedDocument) return;

    const classification = savedDocument.DocumentClassification;
    const uploadedDocument = {
      id: "",
      documentClassificationId: classification,
      documentStatusId: DocumentApi.DOCUMENT_STATUS_NEW,
      documentName: savedDocument.FileName,
      creationTime: savedDocument.ReceivedDateTime,
      modifiedTime: savedDocument.ReceivedDateTime,
      isViewed: false,
    };

    this.setState((state) => ({
      notificationModalOpen: true,
      notificationModalMessage: metadataService.getMessage(
        "DocumentProofSubmitted",
        this.getClassificationText(classification)
      ),
      uploaded: {
        ...state.uploaded,
        [classification]: [uploadedDocument, ...(state.uploaded[classification] || [])],
      },
    }));
  };

  // Documents already on file for this lead (from the guest state) plus any
  // uploaded during this session, newest first.
  getDocuments(classification, maxDocuments) {
    const existing = (this.props.documents || [])
      .filter((doc) => doc.documentClassificationId === classification)
      .map((doc) =>
        moment(doc.creationTime) > moment(doc.modifiedTime)
          ? { ...doc, modifiedTime: doc.creationTime }
          : doc
      )
      .sort((d1, d2) => moment(d2.modifiedTime) - moment(d1.modifiedTime));

    return [...(this.state.uploaded[classification] || []), ...existing].slice(0, maxDocuments);
  }

  render() {
      const { leadId, userHash, guestLoading, usePersona } = this.props;
      const { notificationModalOpen, notificationModalMessage, personaComplete } = this.state;

      const idDocs = this.getDocuments(DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT, 1);
      const showPersona = usePersona && idDocs.length === 0 && !personaComplete;

    return (
      <div>
        <h6 className="pb-3">
          {metadataService.getTitle("ConfirmationApplicationReceived")}
        </h6>

        <p>
          {metadataService.getMessage("PleaseCompleteSteps")}
          <ul>
            <li>{metadataService.getMessage("PleaseCompleteSteps1")}</li>
            <li>{metadataService.getMessage("PleaseCompleteSteps2")}</li>
            <li>{metadataService.getMessage("PleaseCompleteSteps3")}</li>
          </ul>
        </p>

        <SlBusyIndicator visible={guestLoading} />
        {!guestLoading && (
            <div>
                {showPersona === true ? 
                    <Row>
                        <Persona leadId={leadId} onComplete={() => this.setState({ personaComplete: true })} />
                    </Row>
                    :
                    <DocumentCard
                      documents={idDocs}
                      viewDocument={() => {}}
                      leadId={leadId}
                      documentClassificationId={DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT}
                      openNotificationModal={this.openNotificationModal}
                      userHash={userHash}
                    />
                }
                <DocumentCard
                  documents={this.getDocuments(DocumentApi.DOCUMENT_CLASSIFICATION_INCOME, 2)}
                  viewDocument={() => {}}
                  leadId={leadId}
                  documentClassificationId={DocumentApi.DOCUMENT_CLASSIFICATION_INCOME}
                  openNotificationModal={this.openNotificationModal}
                  maxAllowedFiles={2}
                  userHash={userHash}
                />
                <DocumentCard
                  documents={this.getDocuments(DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE, 1)}
                  viewDocument={() => {}}
                  leadId={leadId}
                  documentClassificationId={DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE}
                  openNotificationModal={this.openNotificationModal}
                  maxAllowedFiles={1}
                  userHash={userHash}
                />
            </div>
        )}

        <NotificationModal
          open={notificationModalOpen}
          ok={this.closeNotificationModal}
          message={notificationModalMessage}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { userHash, loading } = state.guest;
  const { language } = state.users;
  return {
    userHash,
    guestLoading: loading,
    language,
  };
};

export default connect(mapStateToProps)(GuestLeadDocuments);
